/*!
=========================================================
* Painel Toca da Onça — Fornecedores por região
=========================================================
* Dados reais da base pública de CNPJ (OpenCNPJ) via fornecedores.json.
* Amostra até baixar a base completa da Receita.
*/
import React from "react";
import {
  Card, CardBody, CardTitle, Button, Row, Col, Badge, Input, FormGroup, Label,
} from "reactstrap";

const UF_NOME = {
  SP: "São Paulo", PE: "Pernambuco", MG: "Minas Gerais", RS: "Rio Grande do Sul",
  PR: "Paraná", SC: "Santa Catarina", RJ: "Rio de Janeiro", BA: "Bahia",
  CE: "Ceará", GO: "Goiás", RN: "Rio Grande do Norte",
};

function Fornecedores() {
  const [dados, setDados] = React.useState([]);
  const [uf, setUf] = React.useState("TODOS");

  React.useEffect(() => {
    fetch("/fornecedores.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && d.fornecedores) setDados(d.fornecedores);
      })
      .catch(() => {});
  }, []);

  const ufs = Array.from(new Set(dados.map((f) => f.uf))).sort();
  const lista = uf === "TODOS" ? dados : dados.filter((f) => f.uf === uf);

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>
            Fornecedores de roupa &amp; tecido
          </h3>
          <p className="text-muted">
            Escolha a região e veja fábricas, atacados e confecções com endereço, mapa e
            contato. Dados públicos da Receita (CNPJ).
          </p>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <Label className="text-muted">Região</Label>
            <Input type="select" value={uf} onChange={(e) => setUf(e.target.value)}>
              <option value="TODOS">Todas as regiões ({dados.length})</option>
              {ufs.map((u) => (
                <option key={u} value={u}>
                  {UF_NOME[u] || u} ({dados.filter((f) => f.uf === u).length})
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        {lista.map((f, i) => (
          <Col lg="6" key={i}>
            <Card>
              <CardBody>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <CardTitle tag="h4" className="text-white" style={{ marginBottom: 4 }}>
                    {f.nome}
                  </CardTitle>
                  <Badge color="primary" pill>{f.uf}</Badge>
                </div>
                <p className="text-info" style={{ marginBottom: 6 }}>{f.ramo}</p>
                <p className="text-muted" style={{ marginBottom: 4 }}>
                  <i className="tim-icons icon-square-pin" /> {f.endereco} — {f.municipio}
                </p>
                <p className="text-muted" style={{ marginBottom: 12, fontSize: 12 }}>
                  CNPJ {f.cnpj} · CEP {f.cep}
                </p>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <Button color="info" size="sm" href={f.maps} target="_blank" tag="a">
                    <i className="tim-icons icon-pin" /> Mapa
                  </Button>
                  {f.telefone && (
                    <Button color="default" size="sm" href={"tel:+55" + f.telefone} tag="a">
                      <i className="tim-icons icon-mobile" /> Ligar
                    </Button>
                  )}
                  {f.whatsapp ? (
                    <Button color="success" size="sm" href={"https://wa.me/" + f.whatsapp} target="_blank" tag="a">
                      <i className="fab fa-whatsapp" /> WhatsApp
                    </Button>
                  ) : (
                    <Button color="success" size="sm" outline disabled>
                      <i className="fab fa-whatsapp" /> sem celular
                    </Button>
                  )}
                  {f.email && (
                    <Button color="default" size="sm" href={"mailto:" + f.email} tag="a">
                      <i className="tim-icons icon-email-85" /> E-mail
                    </Button>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
        {lista.length === 0 && (
          <Col xs="12">
            <Card><CardBody>
              <p className="text-muted">
                Sem fornecedores carregados ainda. Rode: node scripts/fetch-fornecedores.js
                — ou autorize baixar a base completa da Receita pra encher todas as regiões.
              </p>
            </CardBody></Card>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default Fornecedores;
